import { ref } from 'vue'

const WORDS_KEY = 'timurka-word-stats'
const TTL_MS = 5 * 24 * 60 * 60 * 1000

function pruneOld(attempts) {
  const cutoff = Date.now() - TTL_MS
  return attempts.filter(a => a.date > cutoff)
}

function pruneAll(raw) {
  const cleaned = {}
  for (const key of Object.keys(raw)) {
    const pruned = pruneOld(raw[key])
    if (pruned.length) cleaned[key] = pruned
  }
  return cleaned
}

function loadStats() {
  try {
    const raw = localStorage.getItem(WORDS_KEY)
    if (raw) return pruneAll(JSON.parse(raw))
  } catch {}
  return {}
}

const stats = ref(loadStats())

function saveStats() {
  localStorage.setItem(WORDS_KEY, JSON.stringify(stats.value))
}

export function useWordStats() {
  function record(source, word, correct, timeMs) {
    const key = `${source}::${word}`
    if (!stats.value[key]) stats.value[key] = []
    stats.value[key].push({ correct, time: timeMs, date: Date.now() })
    const cleaned = pruneAll(stats.value)
    stats.value = cleaned
    saveStats()
  }

  function getSessionSummary(history) {
    if (!history.length) return null
    const perfect = history.filter(h => (h.errors !== undefined ? h.errors === 0 : h.correct)).length
    const withErrors = history.length - perfect
    const times = history.filter(h => h.time).map(h => h.time).sort((a, b) => a - b)
    let avgTime = 0
    if (times.length > 4) {
      const trimmed = times.slice(2, -2)
      avgTime = Math.round(trimmed.reduce((s, t) => s + t, 0) / trimmed.length / 100) / 10
    } else if (times.length) {
      avgTime = Math.round(times.reduce((s, t) => s + t, 0) / times.length / 100) / 10
    }
    return { total: history.length, perfect, withErrors, avgTime }
  }

  function resetStats() {
    stats.value = {}
    saveStats()
  }

  return { stats, record, getSessionSummary, resetStats }
}

export async function loadWords(filename) {
  const resp = await fetch(`/${filename}`)
  const text = await resp.text()
  return text
    .split('\n')
    .map(l => l.trim())
    .filter(l => l && !l.startsWith('🐾') && !l.startsWith('🦋') && !l.startsWith('🌳') && !l.startsWith('🏠') && !l.startsWith('🍎') && !l.startsWith('👕') && !l.startsWith('🚗') && !l.startsWith('😊') && !l.startsWith('('))
}

export async function loadSentences(level) {
  const filename = `manywords${level}.txt`
  const lines = await loadWords(filename)
  return lines.filter(l => l.length > 5)
}

export async function loadStories() {
  const lines = await loadWords('text1.txt')
  return lines.map(l => {
    const parts = l.split('|')
    return {
      title: parts[0] || '',
      text: (parts[1] || parts[0] || '').trim(),
    }
  }).filter(s => s.text.length > 10)
}

export function splitToSyllables(word) {
  return word.split('-')
}
